<script>
import NavBar from "@/components/NavBar";
import SideBarReports from "@/components/SideBarReports";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    SideBarReports,
    FooterBar
  },
  computed: {
    isPrintingThroughputRoute() {
      return this.$route && this.$route.name === 'PrintingThroughputReport';
    }
  },
  data() {
    return {
      sidebarCollapsed: false
    }
  },
  methods: {
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
    }
  }
}
</script>

<style scoped src="@/assets/css/inbox.css">
</style>

<style scoped>
.sidebar-toggle {
  position: absolute;
  top: 50%;
  right: -14px;
  transform: translateY(-50%);
  z-index: 10;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  font-size: 12px;
}
.sidebar-column {
  position: relative;
  transition: all 0.2s ease;
}
</style>

<template>
  <div>
    <nav-bar />

    <section class="main-content columns is-fullheight">
      <div class="sidebar-column column" :class="sidebarCollapsed ? 'is-narrow' : 'is-2'">
        <SideBarReports v-show="!sidebarCollapsed" />
        <button
          v-if="!isPrintingThroughputRoute"
          class="button is-light is-small sidebar-toggle"
          @click="toggleSidebar"
          :title="sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'">
          {{ sidebarCollapsed ? '▶' : '◀' }}
        </button>
      </div>

      <div class="column" :class="sidebarCollapsed ? 'is-fullwidth' : 'is-10'">
        <div class="section">
          <router-view
            :reports-sidebar-collapsed="sidebarCollapsed"
            @toggle-reports-sidebar="toggleSidebar"
          />
        </div>
      </div>
    </section>

    <footer-bar />

  </div>

</template>

